import axios from "axios";
import AuthHandler from "../authenticationHandler";
import CONSTANTS from "../constants";
import APICONSTANTS from "../../../services/api/constants";
import Constants from "../../../constants/text-constants";

let instance = null;

const ALERT_EVENT = "ALERT_EVENT";
const target = new EventTarget();
const event = new CustomEvent(ALERT_EVENT, {
  detail: {
    status: 403,
    message: Constants.ERROR_RESPONSE_MESSAGE,
    url: "",
  }
});

const ignoredEndpoints = [
  APICONSTANTS.API_CONSTANTS.ENDPOINTS.CUSTOM_VALUE,
];

const dispatchPermissionAlert = (response) => {
  if(response.config)  {
    event.detail.url = response.config.url;

    if( ignoredEndpoints.some( (element) => { return event.detail.url.includes(element) } ) ){
      // ignore it
      return;
    }
  } else {
    event.detail.url = "";
  }

  target.dispatchEvent(event);
}

const getInstance = async (timeout = 35000) => {
  if (instance == null) {
    instance = axios.create({
      baseURL: CONSTANTS.API_CONSTANTS.API_BASE_URL,
    });

    // create an instance interceptor to intercept the responses and handle 401 and 403 responses
    instance.interceptors.response.use((response) => {
      // this is a success so 2XX range http response
      return response;
    }, (error) => {
      if (error.response) {

        switch (error.response.status) {
          case 401:
            AuthHandler.signoutAndRedirectToLogin();

            break;
          case 403:
            // alert to user and refresh permissions
            dispatchPermissionAlert(error.response);
            break;

          default:
            break;
        }
      }
      return Promise.reject(error);
    })
  }

  // set the default request timeout
  instance.defaults.timeout = timeout;

  // get an access token
  let accessToken = null;
  try {
    accessToken = await AuthHandler.getToken();
  } catch (error) {
    throw error;
  }

  // set the auth header to the retrieved access token
  instance.defaults.headers.common[
    CONSTANTS.HTTP_HEADER.FIELD.AUTHORIZATION
  ] = `${CONSTANTS.HTTP_HEADER.AUTHORIZATION_VALUE.BEARER} ${accessToken}`;

  return instance;
};

const addAlertListener = (callback) => {
  target.addEventListener(ALERT_EVENT, callback);

}

const removeAlertListener = (callback) => {
  target.removeEventListener(ALERT_EVENT, callback);
}

// Allow consumer of axios to get a cancellation token.
// Axios hangs if the web server accepts the connection, but doesn't return any
// response, so we need a suitable timeout
const getTimedCancelToken = (cancelTimeout) => {
  if (!instance) {
    return null;
  }

  const instanceTimeout = instance.defaults.timeout;
  let cancelToken = axios.CancelToken;
  let source = cancelToken.source();

  setTimeout(() => {
    source.cancel("Cancellation token timer expired");
  }, cancelTimeout ? cancelTimeout : instanceTimeout + 1000);

  return source;
}

export default {
  getInstance,
  getTimedCancelToken,
  addAlertListener,
  removeAlertListener,
};
